// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".5284d66a8692683a8e80a769d60be7014522abff.chunk.js";
};